export const mobileMenuHideConfig = ['/inbox/thread'];